var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AccountSelect from "./atoms/AccountSelect";
import ProfileLoader from "./atoms/ProfileLoader";
import { InnerContentWrapper } from "./subcomponents";
import EditProfile from "./templates/EditProfile";
import ErrorPage from "./templates/ErrorPage";
import ShowProfile from "./templates/ShowProfile";
import routes from "../const/routes";
import { useAccountSummary, useProfile, useProfileScope, } from "../const/syfApiQueries";
import { useProfileGlobalState } from "../context/profileGlobalState";
import createInitialProfileFormState from "../helpers/createInitialProfileFormState";
import { getProfileSessionAction, setProfileSessionAction, } from "../helpers/profileSessionStorage";
import updateFormValues from "../helpers/updateFormValues";
import { useConfig } from "../hooks/useConfig";
import useCurrentAccount from "../hooks/useCurrentAccounts";
import { ProfileLayout } from "../layout";
import parseQueryErrors from "../helpers/parseQueryErrors";
import triggerProfileAnalytics from "../helpers/triggerProfileAnalytics";
import { PAGE_NAME } from "../const/analytics";
var Profile = function (_a) {
    var _b, _c, _d, _e;
    var authenticationRedirect = _a.authenticationRedirect;
    var profileConfig = useConfig();
    var _f = useProfileGlobalState(), _g = _f.state, selectedAccountId = _g.selectedAccountId, shouldEditProfile = _g.shouldEditProfile, dispatch = _f.dispatch;
    var i18n = useTranslation().i18n;
    var accounts = useCurrentAccount(selectedAccountId);
    var selectedAccountOption = accounts.selectedAccountOption, accountsOptions = accounts.accountsOptions;
    var accountId = (_b = accounts.selectedAccountOption.value) !== null && _b !== void 0 ? _b : selectedAccountId;
    var accountSummary = useAccountSummary(accountId, profileConfig);
    var profileQuery = useProfile(accountId, profileConfig);
    var profileScope = useProfileScope(accountId, profileConfig);
    var queries = [profileQuery, accountSummary];
    var isLoading = queries.some(function (query) { return query.isLoading; });
    var isError = queries.some(function (query) { return query.isError; });
    var hasAccountOptions = accountsOptions.length > 0;
    var showAccountSelect = hasAccountOptions && Boolean(selectedAccountOption);
    var shouldRenderAccountSelect = Boolean(showAccountSelect && selectedAccountOption && accountsOptions.length > 1);
    var shouldShowLoader = !accounts.accountError && (isLoading || accounts.isLoading);
    var form = useForm({
        defaultValues: createInitialProfileFormState((_c = profileQuery.data) === null || _c === void 0 ? void 0 : _c.profile),
        mode: "all",
    });
    var reset = form.reset, isSubmitting = form.formState.isSubmitting;
    var goToEditProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (profileScope.isError) {
                setProfileSessionAction("edit");
                sessionStorage.removeItem("accessToken");
                authenticationRedirect({
                    scope: "read write write:sensitive profile:read:sensitive",
                    navigateTo: routes.PROFILE,
                });
            }
            if (!profileScope.isError) {
                dispatch({ shouldEditProfile: true });
                setProfileSessionAction("edit");
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        i18n.changeLanguage(profileConfig.lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileConfig.lang]);
    useEffect(function () {
        if (!profileScope.isError && !profileScope.isLoading) {
            var isEditing = getProfileSessionAction() === "edit";
            if (isEditing) {
                dispatch({ shouldEditProfile: true });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileScope.isError, profileScope.isLoading]);
    useEffect(function () {
        if (profileQuery.data && shouldEditProfile) {
            var updatedFormValues = updateFormValues(profileQuery.data);
            reset(updatedFormValues);
        }
    }, [profileQuery.data, reset, shouldEditProfile]);
    if (isError ||
        accounts.accountError ||
        (!accounts.isLoading && accounts.accountsList.length <= 0)) {
        triggerProfileAnalytics({
            pageName: PAGE_NAME.ERROR,
            errorMessage: parseQueryErrors(accounts.accountErrorMessage, (_d = accountSummary.error) === null || _d === void 0 ? void 0 : _d.message, (_e = profileQuery.error) === null || _e === void 0 ? void 0 : _e.message),
        });
        return _jsx(ErrorPage, {});
    }
    return (_jsxs(ProfileLayout, { children: [shouldRenderAccountSelect && (_jsx(InnerContentWrapper, { children: _jsx(AccountSelect, { shouldDisableAccountSelect: isSubmitting }) })), shouldShowLoader && _jsx(ProfileLoader, {}), !shouldShowLoader &&
                (shouldEditProfile ? (_jsx(FormProvider, __assign({}, form, { children: _jsx(EditProfile, {}) }))) : (_jsx(ShowProfile, { goToEditProfile: goToEditProfile })))] }));
};
export default Profile;
